import React from 'react';
import cn from 'classnames';
import { Text } from '../../typography/esm';

var styles = {"component":"comment__component_g6y22","rowLimit2":"comment__rowLimit2_g6y22","rowLimit5":"comment__rowLimit5_g6y22"};
require('./index.css');

var Comment = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, children = _a.children, rowLimit = _a.rowLimit;
    var textClassName = rowLimit && styles["rowLimit".concat(rowLimit)];
    return (React.createElement("div", { className: cn(styles.component, className), "data-test-id": dataTestId },
        React.createElement(Text, { tag: 'div', view: 'component-primary', className: textClassName, color: 'primary' }, children)));
};

export { Comment };
